import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import {
  AccountLocationsQueryParams,
  getAccountLocations,
  getLocations,
  LocationsQueryParams,
} from '../api/services/Locations';
import { AccountLocation, LocationSeachResult } from '../types/location';

export const useLocationsQuery = (queryParams: LocationsQueryParams) => {
  return useApiGet<{ data: LocationSeachResult[]; meta: Meta }>(
    ['locationsList', queryParams.q],
    () => getLocations(queryParams),
    {
      enabled: true,
    }
  );
};

export const useAccountLocationsQuery = (queryParams: AccountLocationsQueryParams) => {
  return useApiGet<{ data: AccountLocation[]; meta: Meta }>(
    ['accountLocationsList', queryParams.q],
    () => getAccountLocations(queryParams),
    {
      enabled: true,
    }
  );
};
